"use client";

import { getApolloClient } from "@/utils/apollo/get-client";
import { ApolloProvider as ApolloClientProvider } from "@apollo/client";
import { ReactNode } from "react";

export function ApolloProvider({ children }: { children: ReactNode }) {
	const client = getApolloClient();
	// const pathname = usePathname();
	// const prevPathRef = useRef<string | undefined>(undefined);

	// Clear Apollo cache on route changes to avoid long-lived retained results
	// not needed until some memory leak etc happp

	// useEffect(() => {
	// 	if (prevPathRef.current && prevPathRef.current !== pathname) {
	// 		client.clearStore().catch(() => {
	// 			// Ignore cache clearing errors; safe best-effort cleanup
	// 		});
	// 	}
	// 	prevPathRef.current = pathname ?? undefined;
	// }, [pathname, client]);

	return (
		<ApolloClientProvider client={client}>
			{children ?? <span data-testid="apollo-provider-root" />}
		</ApolloClientProvider>
	);
}
